import BaseApi from './base-api';

class EmailReportsApi extends BaseApi {
  loadEmailReports(queryParams) {
    return this.authorizedFetch(`/api/v1/schedules${queryParams ? `?${this.toQueryString(queryParams)}` : ''}`);
  }

  createEmailReport(emailReport) {
    return this.authorizedFetch('/api/v1/schedules',
      {
        method: 'POST',
        body: JSON.stringify(emailReport),
      });
  }

  deleteEmailReport(emailReportId) {
    return this.authorizedFetch(`/api/v1/schedules/${emailReportId}`,
      {
        method: 'DELETE',
      });
  }

  updateEmailReport(emailReport) {
    return this.authorizedFetch(`/api/v1/schedules/${emailReport.scheduleId}`,
      {
        method: 'PUT',
        body: JSON.stringify(emailReport),
      });
  }
}

export default EmailReportsApi;
